module.exports = __webpack_public_path__ + "static/media/check-grey-back.5aef0bf2.svg";